import { Component, OnInit ,Input,EventEmitter, Output} from '@angular/core';
import { Router } from '@angular/router' ;

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.css']
})
export class ConfirmationModalComponent implements OnInit {
  @Input() PData: any;
  @Output()emitPass: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private router:Router,
  ) { }

  ngOnInit() {
  }
 
commonMethod(){
  this.emitPass.emit();
}
}
